import { IRequesterInfo } from '../../../../base/models/proxyModels'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { DealerForPagePathRequest, DealerForPageMailPathResponse } from './models'

export class DealerForPagePathFromMailService extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/GA4Reporting/DealerForPagePathFromMailSource',
      requesterInfo,
    })
  }

  public async DealerForPagePathFromMailSource(
    req: DealerForPagePathRequest
  ): Promise<DealerForPageMailPathResponse[]> {
    return await this.postAsync<DealerForPageMailPathResponse[]>(req)
  }
}
